import { getToken, getUser } from "../Utils/Common";
import { getAPICall, postAPICall, getWithParamsAPICall } from "./axiosMethodCalls";

//GET
export const getShow = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "menus/show"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getAllMenu = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "menus/getAll"
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

//GET
export const getAllMenuByCategory = async (category_id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "menus/category",
            {
                category_id: category_id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getVAT = async (vatIn) => {
    let config = {
        headers: {
            "api-key": "fJcibSRzJQv2NmJmzgnxsgMu56ucqpLBlJIA9FfaQMI9XxQ0Kxm2sEoMQfwisy0b",
        }
    }
    try {
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "vats/computation", {
                requester: getUser(),
                token: getToken(),
                vat_in: vatIn.price,
                // vat_in: edit.price,
                is_vatable: vatIn.is_vatable,
                // is_vatable: edit.is_vatable === true ? 0 : 1
            }, config
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};
